import useInterval from 'beautiful-react-hooks/useInterval';
import { addDays, startOfDay } from 'date-fns';
import React from 'react';
import { useCookies } from 'react-cookie';

export default function useReminderNotification(notificationPermission: string) {
  const [cookies, setCookies, clearCookies] = useCookies(['reminderNotify']);

  useInterval(() => {
    if (cookies.reminderNotify) {
      const expirationTimestamp = parseInt(cookies.reminderNotify, 10);
      if (Date.now() > expirationTimestamp) {
        clearCookies('reminderNotify');
      }
    }
  }, 60000);

  const openCondition = React.useMemo(() => {
    if (notificationPermission !== 'denied') return false;
    if (!cookies.reminderNotify) return true;
    return false;
  }, [notificationPermission, cookies.reminderNotify]);

  return {
    open: openCondition,
    onClose: () => {
      const expirationTimestamp = startOfDay(addDays(Date.now(), 1)).getTime();

      setCookies(
        'reminderNotify',
        expirationTimestamp,
        {
          path: '/', maxAge: (expirationTimestamp - Date.now()) / 1000, secure: true, sameSite: 'strict',
        },
      );
    },
  };
}
